import template from './rooms-for-rent-total-count.jade';
import validation from '../../../services/validation';
import plainRoomsCount from '../../../enums/plain-rooms-count';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.roomsForRentTotalCount', [])
  .directive('cianAfAboutObjectRoomsForRentTotalCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'adTooltipsService',
      '$scope',
      'analyticsService',
      'deviceService',
      'popupService',
      'store',
      function (adTooltipsService, $scope, analyticsService, deviceService, popupService, store) {
        this.isMobile = deviceService.isMobile;
        this.modalHintTitle = 'Всего комнат в квартире';
        if (this.ad.roomsCount && this.ad.roomsCount < 2) {
          delete this.ad.roomsCount;
        }
        this.items = plainRoomsCount.filter(item => item.value !== 1);
        this.getMinRoomsCount = () => Number(this.ad.roomsForSaleCount);
        this.ad.flatType = 'rooms';

        this.validation = validation(this.form, 'roomsForRentTotalCount', {
          required: 'Выберите значение',
          min: 'Количество комнат должно быть больше чем количество комнат в аренду',
        });

        this.handleChange = () => {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'total_number_of_rooms');
        };

        initializeSegmentInputTooltips({
          controller: this,
          $scope,
          adTooltipsService,
          adAnalyticsCategory: analyticsService.adAnalyticsCategory,
          tooltipsKey: 'roomsCount',
          trackingLabel: 'rooms-for-rent-total-count-hint',
          popupService,
          isMobile: this.isMobile,
        });
      },
    ],
    controllerAs: 'roomsForRentTotalCount',
    template,
  })).name;
